export const NEWSLETTER_FEEDBACK_FORM_NAME = 'newsletterFeedback'
